import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import Loading from '../../components/Loading';

import accountRouter from '../account';

const PageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dasvistapro-dashboard-page" */ '../../pages/dasvistapro-dashboard/index'
    ),
);

const dasloopDashboardRouter = (
  <Route path="dasvistapro-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <PageComponent />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default dasloopDashboardRouter;
